import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.js';
import './index.css';

/** §13 — Vite giriş noktası. `index.html` içindeki #root'a bağlanır. */

const container = document.getElementById('root');
if (container === null) {
  throw new Error('#root bulunamadı — index.html bozuk.');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
